/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { FolderPath } from 'cio/components/asset-library';

interface AssetLibraryToolbarFolderDropdownButtonArgs {
  folderPaths: FolderPath[];
  folderPathsToExclude?: FolderPath[];
  onClick: (folderPath: FolderPath) => unknown;
}

export default class AssetLibraryToolbarFolderDropdownButton extends Component<AssetLibraryToolbarFolderDropdownButtonArgs> {
  get folderPaths() {
    if (this.args.folderPathsToExclude == null || this.args.folderPathsToExclude.length === 0) {
      return this.args.folderPaths;
    }

    let excludedFolderIds = this.args.folderPathsToExclude.map((f) => f.id);
    return this.args.folderPaths.filter((f) => !excludedFolderIds.includes(f.id));
  }
}
